import {responseResolveInterceptor} from './interceptors';
import {formDataArrayToRequestParams, formDataToRequestParams, getAxios} from './axios';
import {addAuthTokenData} from './member';

function doPayment(url, {t, cn, exp_month, exp_year, cvv, email, ...rest}) {
    let axios = getAxios({forcedSSL: true});

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: url,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({t, cn, exp_month, exp_year, cvv, email, ...rest}))
    });
}

function doPaymentOrder(url, {amount, t, ...rest}) {
    let axios = getAxios({forcedSSL: true});

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: url,
        method: 'post',
        data: formDataArrayToRequestParams(addAuthTokenData({amount, t, ...rest}))
    });
}

export function paymentMembership({t, cn, exp_month, exp_year, cvv, email, ...rest}) {
    let formData = {t, cn, exp_month, exp_year, cvv, email};

    if (rest.r) formData.r = rest.r;
    if (rest.message) formData.message = rest.message;
    if (rest.returnPath) formData.return_path = rest.returnPath;

    //return doPayment('/payment/membership/', formData);
    return doPayment('/payment/auth/', formData);
}

export function paymentWallet({t, finalizeGiftId, cn, exp_month, exp_year, cvv, email, ...rest}) {
    let formData = {t, finalizeGiftId, cn, exp_month, exp_year, cvv, email};

    if (rest.returnPath) formData.return_path = rest.returnPath;

    //return doPayment('/payment/wallet/', formData);
    return doPayment('/payment/auth/', formData);
}

export function paymentOrder({amount, t, receiver_id, message, ...rest }) {
    let formData = { amount, t };
    if (receiver_id) formData.receiver_id = receiver_id;
    if (message) formData.message = message;

    return doPaymentOrder('/payment/order/', formData);
}

export function paymentOrderUpdate({ id, name, ...rest }) {
    let formData = { id, name };

    let axios = getAxios({forcedSSL: true});

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: 'payment/order/update/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(formData))
    });
}




// WEBPACK FOOTER //
// ./src/backend-helpers/payment.js